export const registerPushDevice: (jwt: string) => Promise<boolean> = async () =>
  false

export const watchPushTokenRefresh: (jwt: string) => () => void = () => () =>
  undefined
